import React from 'react';
import { ItemNumberValue } from 'components/project/ClerkScreen';
import { Container } from './Styles';

const ItemNumber = () => (
  <Container>
    <ItemNumberValue labelText="Item#" />
  </Container>
);

export default ItemNumber;
